export default function() {
    //this.enableInputs();
    if (this.current == "login") {
        let valid = true;
        const email = this.userData[this.current].email;
        const password = this.userData[this.current].password;
        if (email == "" || password == "") {
            this.errorMessage = "Please complete the fields.";
            valid = false;
        } else {
            if (email != "" && !this.validateEmail(email)) {
                this.errorMessage = "Please insert a valid email address.";
                valid = false;
            } else {
                this.errorMessage = "";
            }
        }

        return valid;
    }

    if (this.current == "register") {
        let valid = true;
        const fullName = this.userData[this.current].fullName;
        const username = this.userData[this.current].username;
        const email = this.userData[this.current].email;
        const password = this.userData[this.current].password;
        const confirmPassword = this.userData[this.current].confirmPassword;

        if (fullName.value == "" || username.value == "" || email.value == "" || password.value == "" || confirmPassword.value == "") {
            this.errorMessage = "Please complete all the fields.";
            valid = false;
        } else {
            this.errorMessage = "";
        }

        if (fullName.value != "" && !this.validateFullName(fullName.value)) {
            this.errorData.fullName = "Please insert your name correctly (alphabetical only).";
            valid = false;
        } else {
            this.errorData.fullName = "";
        }

        if (email.value != "" && !this.validateEmail(email.value)) {
            this.errorData.email = "Please insert a valid email address.";
            valid = false;
        } else {
            this.errorData.email = "";
        }


        if (username.value != "" && !this.validateUsername(username.value)) {
            valid = false;
        } else {
            this.errorData.username = "";
        }

        let res = this.validatePassword(password.value);
        if (password.value != "") {
            if (!res.status) {
                this.errorData.password = res.message;
                valid = false;
            } else if (confirmPassword.value != password.value) {
                this.errorData.password = "Passwords do not match.";
                valid = false;
            } else {
                this.errorData.password = "";
            }
        }

        return valid;
    }

    if (this.current != "register" && this.current != "login") {
        if (this.dataInput.value == "") {
            this.errorMessage = "Please complete the field.";
            if (this.current == 'password' || this.current == 'reset_password') {
                this.errorMessage = "Please complete the fields.";
            }
            return false;
        } else {
            if (this.current == "forgot" && !this.validateEmail(this.dataInput.value)) {
                this.errorMessage = "Please insert a valid email address.";
                return false;
            }

            if (this.current == 'password' || this.current == 'reset_password') {
                let res = this.validatePassword(this.dataInput.value);
                if (!res.status) {
                    this.errorMessage = res.message;
                    return false;
                } else if (document.querySelector('.confirmPassword').value != this.dataInput.value) {
                    this.errorMessage = "Passwords do not match.";
                    return false;
                }
            }

            if (this.current == 'fullName' && !this.validateFullName(this.dataInput.value)) {
                this.errorMessage = "Please insert your name correctly (alphabetical only).";
                return false;
            }

            if (this.current == 'username' && !this.checkUsernameLegacy(this.dataInput.value)) {
                return false;
            }

            if (this.current == 'email' && !this.validateEmail(this.dataInput.value)) {
                this.errorMessage = "Please insert a valid email address.";
                return false;
            }

            if (this.current == 'zipcode' && !this.validateZipCode(this.dataInput.value)) {
                this.errorMessage = "Please insert a valid zipcode (alphanumeric only).";
                return false;
            }

            this.errorMessage = "";
            return true;
        }
    }
};
